export const createEvent = ({token, event}) => {
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/create-event`, {
    method: 'POST',
    body: JSON.stringify({
      event,
    }),
    headers: {
      token,
    },
  })
}

export const getEvents = ({token, date}) =>
  fetch(
    `${process.env.GATSBY_FUNCTION_PATH}/get-events?date=${date.toISOString()}`,
    {
      method: 'GET',
      headers: {
        token,
      },
    },
  )

export const getWorkingGroupsEvents = ({token, date}) =>
  fetch(
    `${
      process.env.GATSBY_FUNCTION_PATH
    }/get-working-groups-events?date=${date.toISOString()}`,
    {
      method: 'GET',
      headers: {
        token,
      },
    },
  )

export const getUpcomingWorkingGroupsEvents = ({token}) =>
  fetch(
    `${process.env.GATSBY_FUNCTION_PATH}/get-upcoming-working-groups-events`,
    {
      method: 'GET',
      headers: {
        token,
      },
    },
  )

export const deleteEvent = ({token, event}) => {
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/delete-event`, {
    method: 'POST',
    body: JSON.stringify({
      event,
    }),
    headers: {
      token,
    },
  })
}

export const getOrganizers = ({accessToken}) => {
  return fetch(`${process.env.GATSBY_BOX_API_URL}/users/`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken.accessToken}`,
    },
  })
}

export const editEvent = ({token, event, eventId}) => {
  return fetch(
    `${process.env.GATSBY_FUNCTION_PATH}/edit-event?eventId=${eventId}`,
    {
      method: 'PUT',
      body: JSON.stringify({
        event,
      }),
      headers: {
        token,
      },
    },
  )
}
